import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { formatCurrency } from '../helpers'
import { NText, SBText } from 'application/components/styledComponents/text'
import { useWindowSize } from '../helpers'
import { getCurrentResolutionBreakPoint } from 'application/utils/utilityFunctions'
import { useSelector } from 'react-redux'
import * as E from './cardRowItemElements'

export const CardRowItem = (props) => {
  let cardClass = `text-right ${props.rightTextcss && props.rightTextcss}`
  const isDownloadingPdf = useSelector(
    (state) => state.downloadPdf && state.downloadPdf.isDownloading
  )
  const [width] = useWindowSize()
  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  if (width < resolutionBreakpoint.nonDesktop) {
    cardClass = `font-weight-normal ${props.rightTextcss && props.rightTextcss}`
  }

  const isDesktop = width >= resolutionBreakpoint.nonDesktop
  const isMobile = !isDesktop

  return (
    <>
      {!props.hideIfNoValue && isDesktop && (
        <Row>
          <Col className="" xs={7} md={props.longVal ? 8 : 9}>
            {props.normalWeight ? (
              <NText id={props.id + '.title'}>{props.title}</NText>
            ) : props.semiboldWeight ? (
              <SBText id={props.id + '.title'}>{props.title}</SBText>
            ) : (
              <div id={props.id + '.title'}>{props.title}</div>
            )}
            {props.subtitle && (
              <div
                className="subtitle"
                id={props.id + '.subtitle'}
              >{` ${props.subtitle}`}</div>
            )}
            {props.subtitle2 && (
              <div
                style={{ fontWeight: 400, fontSize: '16px' }}
                id={props.id + '.subtitle'}
              >{` ${props.subtitle2}`}</div>
            )}
          </Col>
          {props.isCurrency &&
            (props.subtitle2 ? (
              <Col
                xs={5}
                md={props.longVal ? 4 : 3}
                className={cardClass}
                style={{ fontWeight: 400, fontSize: '14px' }}
                id={props.id + '.value'}
              >
                {formatCurrency(props.value)}
              </Col>
            ) : (
              <Col
                xs={5}
                md={props.longVal ? 4 : 3}
                className={cardClass}
                id={props.id + '.value'}
              >
                {formatCurrency(props.value)}
              </Col>
            ))}
          {!props.isCurrency && (
            <Col
              xs={5}
              md={props.longVal ? 4 : 3}
              className={cardClass}
              id={props.id + '.value'}
            >
              {props.value}
            </Col>
          )}
        </Row>
      )}
      {!props.hideIfNoValue && isMobile && (
        <>
          <Row>
            <Col className="" xs={12}>
              {props.normalWeight ? (
                <NText id={props.id + '.title'}>{props.title}</NText>
              ) : props.semiboldWeight ? (
                <SBText id={props.id + '.title'}>{props.title}</SBText>
              ) : (
                <div id={props.id + '.title'}>{props.title}</div>
              )}
              {props.subtitle && (
                <div
                  className="subtitle"
                  id={props.id + '.subtitle'}
                >{` ${props.subtitle}`}</div>
              )}
              {props.subtitle2 && (
                <div
                  style={{ fontWeight: 400, fontSize: '14px' }}
                  id={props.id + '.subtitle2'}
                >{` ${props.subtitle2}`}</div>
              )}
            </Col>
          </Row>
          <Row className="mb-3">
            {props.isCurrency &&
              (props.subtitle2 ? (
                <Col
                  xs={12}
                  style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    textAlign: 'left',
                  }}
                  id={props.id + '.value'}
                >
                  {formatCurrency(props.value)}
                </Col>
              ) : (
                <Col xs={12} className={cardClass} id={props.id + '.value'}>
                  {formatCurrency(props.value)}
                </Col>
              ))}
            {!props.isCurrency && (
              <Col xs={12} className={cardClass} id={props.id + '.value'}>
                {props.value}
              </Col>
            )}
          </Row>
        </>
      )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.value > 0 &&
        isDesktop && (
          <Row>
            <Col xs={7} md={props.longVal ? 8 : 9}>
              {props.title}
              {props.subtitle && (
                <div
                  className="subtitle"
                  style={props.smallSubtitle ? { fontWeight: 400, fontSize: '0.75rem'}:{}}
                  id={props.id + '.subtitle'}
                >{` ${props.subtitle}`}</div>
              )}
            </Col>
            <Col
              xs={5}
              md={props.longVal ? 4 : 3}
              className={cardClass}
              id={props.id + '.value'}
            >
              {formatCurrency(props.value)}
            </Col>
          </Row>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.value > 0 &&
        isMobile && (
          <>
            <Row>
              <Col xs={12}>
                <div id={props.id + '.title'}>{props.title}</div>
                {props.subtitle && (
                  <div
                    className="subtitle"
                    style={props.smallSubtitle ? { fontWeight: 400, fontSize: '0.75rem'}:{}}
                    id={props.id + '.subtitle'}
                  >{` ${props.subtitle}`}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className={cardClass} id={props.id + '.value'}>
                {formatCurrency(props.value)}
              </Col>
            </Row>
          </>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.exclGST > 0 &&
        props.inclGST > 0 &&
        isDesktop && (
          <E.DualValueCurrencyRow>
            <E.DualValueCurrencyTextDiv>
              <span id={props.id + '.title'}>{props.title}</span>
              {props.subtitle && (
                <div
                  className="subtitle"
                  style={props.smallSubtitle ? { fontWeight: 400, fontSize: '0.75rem'}:{}}
                  id={props.id + '.subtitle'}
                >{` ${props.subtitle}`}</div>
              )}
            </E.DualValueCurrencyTextDiv>
            <E.DualValueCurrencyValuesDiv>
              <E.DualValueCurrencyValueDiv id={props.id + '.exclGST'}>
                {formatCurrency(props.exclGST)}
              </E.DualValueCurrencyValueDiv>
              <E.DualValueCurrencyValueDiv id={props.id + '.inclGST'}>
                {formatCurrency(props.inclGST)}
              </E.DualValueCurrencyValueDiv>
            </E.DualValueCurrencyValuesDiv>
          </E.DualValueCurrencyRow>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.exclGST > 0 &&
        props.inclGST > 0 &&
        isMobile && (
          <>
            <Row className="mb-2">
              <Col>
                <div
                  id={props.id + '.title'}
                  style={{
                    color: global.config.isBrandRS && '#000',
                    fontWeight: global.config.isBrandRS && 900,
                  }}
                >
                  {props.title}
                </div>{' '}
                {props.subtitle && (
                  <div
                    className="subtitle"
                    id={props.id + '.subtitle'}
                    style={props.smallSubtitle ? { fontWeight: 400, fontSize: '0.75rem'}:{ color: '#000', fontWeight: 900}}
                    
                  >{` ${props.subtitle}`}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <div className="font-weight-normal text-indictive-color">
                  <b id={props.id + '.exclGST'}>
                    {formatCurrency(props.exclGST)}
                  </b>{' '}
                  (Ex GST)
                </div>
                <div
                  className="font-weight-normal"
                  style={{ color: global.config.isBrandRS && '#000' }}
                >
                  <b id={props.id + '.inclGST'}>
                    {formatCurrency(props.inclGST)}
                  </b>{' '}
                  (Inc GST)
                </div>
              </Col>
            </Row>
          </>
        )}
      {props.hideIfNoValue &&
        !props.isCurrency &&
        props.value !== null &&
        isDesktop && (
          <Row>
            <Col xs={7} md={props.longVal ? 8 : 9}>
              <div id={props.id + '.title'}>{props.title}</div>
              {props.subtitle && (
                <div className="subtitle" id={props.id + '.subtitle'}>
                  {props.subtitle}
                </div>
              )}
            </Col>
            <Col
              xs={5}
              md={props.longVal ? 4 : 3}
              className={cardClass}
              id={props.id + '.value'}
            >
              {props.value}
            </Col>
          </Row>
        )}
      {props.hideIfNoValue &&
        !props.isCurrency &&
        props.value !== null &&
        isMobile && (
          <>
            <Row>
              <Col xs={12}>
                <div id={props.id + '.title'}>{props.title}</div>
                {props.subtitle && (
                  <div className="subtitle" id={props.id + '.subtitle'}>
                    {props.subtitle}
                  </div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className={cardClass} id={props.id + '.value'}>
                {props.value}
              </Col>
            </Row>
          </>
        )}
    </>
  )
}
